'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPaintbrush = function IoPaintbrush(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm9.2 22.1c4.1 0 8 3.2 7.1 8-0.9 4-4.3 5.5-7.1 6-2.3 0.4-7.8 0-9.2-2.7 1.9-0.7 2.7-2.1 2.7-3.9 0-3.8 2.5-7.4 6.5-7.4z m24.9-17.4c1 1 1.3 2.3 0.4 3.5l-12.1 13.7c0.2 0.7 0.1 1.3-0.2 1.8l-3.9 4.5c-0.2 0.2-0.3 0.2-0.5 0-0.1-0.1-0.1-0.2-0.1-0.2v-0.1c0.2-4.1-3.2-6.8-6.9-7h-0.2s-0.1 0-0.1-0.1c-0.2-0.2-0.2-0.3 0-0.5l4.6-3.8c0.4-0.3 1.1-0.3 1.8-0.2l13.7-12c1.1-0.9 2.4-0.6 3.5 0.4z m-23.6 15.6z' })
        )
    );
};

exports.default = IoPaintbrush;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/paintbrush.js
// module id = 2369
// module chunks = 0